import { createHttpLink } from 'apollo-link-http'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { getToken, removeToken } from '@/composables/useAuth'
import { onError } from 'apollo-link-error'
import { useApp } from '@/composables/useApp'
import { AppConfig } from '@/appConfigs'

const httpLink = createHttpLink()

let _currentApp: AppConfig | null = null
const authLink = setContext(async (_, { headers }) => {
  // Use your async token function here:
  // Return the headers to the context so httpLink can read them
  if (_currentApp == null) {
    const { currentApp } = useApp()
    _currentApp = currentApp.value
  }

  return {
    uri: _currentApp.apiUri,
    headers: {
      ...headers,
      'x-hasura-admin-secret': getToken()
    }
  }
})

const resetToken = onError(({ networkError }) => {
  // eslint-disable-next-line
  if (networkError && (networkError as any).statusCode === 401) {
    // remove cached token on 401 from the server
    removeToken()
    window.location.reload()
    networkError = undefined
  }
})

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function createOmitTypenameLink() {
  function omitTypename(key: string, value: unknown): unknown {
    return key === '__typename' ? undefined : value
  }
  return new ApolloLink((operation, forward) => {
    if (operation.variables) {
      operation.variables = JSON.parse(
        JSON.stringify(operation.variables),
        omitTypename
      )
    }

    return forward(operation)
  })
}

const omitTypenameLink = createOmitTypenameLink()

const appLink = ApolloLink.from([
  omitTypenameLink,
  resetToken,
  authLink,
  httpLink
])

const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
  link: appLink,
  cache
})
